import { CategoryType, KnowledgeType } from '@/libs/types'
import { Utils } from '@/libs/Utils'
import clsx from 'clsx'
import Link from 'next/link'
import React from 'react'

interface PostFooterProps {
    previousPage?: KnowledgeType
    nextPage?: KnowledgeType
    category?: CategoryType
    locale: string
}

const Footer: React.FC<PostFooterProps> = ({
    previousPage,
    nextPage,
    category,
    locale
}) => {
    const t = new Utils(locale).Translation
    const previousHref = !previousPage ? "#" : `/${locale}/knowledges/${category?.attributes.slug}/${previousPage?.attributes?.slug}`
    const nextHref = !nextPage ? "#" : `/${locale}/knowledges/${category?.attributes.slug}/${nextPage?.attributes?.slug}`

    return (
        <div className="py-5 d-flex justify-content-between footer">
            {['previous', 'next'].map((name: string) => {

                const active = name === "previous" ? !!previousPage : !!nextPage
                return (
                    <div key={name} className={clsx("h5 fw-light", `footer` + '__' + `${name}page`)}>
                        <Link href={name === 'previous' ? previousHref : nextHref}
                            className={clsx("text-decoration-none", active ? "" : "unactive")}
                            passHref
                        >
                            <span className={clsx("d-flex footer__icon", `footer__icon__` + name)}>
                                {t(`knowledges.${name}`)}
                            </span>
                        </Link>
                    </div>
                )
            })}
        </div>
    )
}

export default Footer